export default __webpack_public_path__ + "static/media/chart.f0d444fd.svg";